// Função para remover espaços, substituir traços por sublinhados e remover parênteses de uma string
export function removeSpecialCharacters(str: string) {
  // Remove espaços e substitui caracteres especiais por "_"
  return str.replace(/[^\w.-]/g, "_");
}
